import { render, staticRenderFns } from "./DigitalDetail.vue?vue&type=template&id=28bd36a6&scoped=true&"
import script from "./DigitalDetail.vue?vue&type=script&lang=js&"
export * from "./DigitalDetail.vue?vue&type=script&lang=js&"
import style0 from "./DigitalDetail.vue?vue&type=style&index=0&id=28bd36a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd36a6",
  null
  
)

export default component.exports